// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore/blob/master/README.md#_chunk
export const chunk = <T>(input: Array<T>, size: number) =>
  input.reduce(
    (arr, item, idx) =>
      idx % size === 0
        ? [...arr, [item]]
        : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]],
    [] as T[][],
  );
